import {
  ScrollToTop,
  ThemeProvider,
  ErrorBoundary,
  CookieProvider,
  CookieConsent,
  useCookieConsent,
} from '@xanectech/components/shared';

import { Toaster, TooltipProvider } from '@xanectech/ui/components';

import { AuthProvider, RoleProvider } from '@xanectech/auth';

import { BrowserRouter, useLocation } from 'react-router-dom';
import { AboutLogger } from '@xanectech/data';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

import { AdminRoutes } from './AppRoutes';

import { HelpProvider } from '@xanectech/components/contexts/HelpContext';

import { createLogger, isFeatureEnabled } from '@xanectech/lib';

const logger = createLogger('Admin App');

// const ScrollToTopHelper = () => {
//   const { pathname } = useLocation();
//   return <ScrollToTop pathname={pathname} />;
// };

/**
 * Conditionally renders Vercel Analytics and Speed Insights based on analytics
 * consent. Uses the consent context so re-renders automatically when consent changes.
 */
const AnalyticsGuard = () => {
  const { checkCategory } = useCookieConsent();
  if (!checkCategory('analytics')) return null;
  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  );
};

const App = () => {
  logger.info('Admin App initialized', { timestamp: Date.now() }, 'admin-app');

  // const helpdexUrl =
  //   import.meta.env.VITE_HELPDEX_URL ?? 'https://helpdex.xanectech.com';
  // const isHelpIntegrationEnabled = isFeatureEnabled(
  //   'ADMIN_HELPDESK_INTEGRATION',
  // );

  return (
    <ThemeProvider defaultTheme='light' storageKey='xanectech-admin-theme'>
      <CookieProvider appName='admin'>
        <ErrorBoundary>
          <TooltipProvider delayDuration={500} skipDelayDuration={200}>
            <Toaster />
            <CookieConsent />
            <AnalyticsGuard />
            <AuthProvider>
              <RoleProvider>
                <BrowserRouter>
                  <HelpProvider app='admin'>
                    <ScrollToTop />
                    <AboutLogger appName='Admin' />

                    <AdminRoutes />
                  </HelpProvider>
                  {/* )} */}
                </BrowserRouter>
              </RoleProvider>
            </AuthProvider>
          </TooltipProvider>
        </ErrorBoundary>
      </CookieProvider>
    </ThemeProvider>
  );
};

export default App;
